import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { ROUTE_SIGNIN } from 'src/app/authentication/shared/routes';

@Component({
    selector: 'app-notification-sent',
    templateUrl: './notification-sent.component.html',
    styleUrls: ['./notification-sent.component.scss'],
    standalone: true,
    imports: [CommonModule, MatButtonModule, MatIconModule]
})
export class NotificationSentComponent implements OnInit {

  message: string;

  constructor(private readonly router: Router) {
    this.message = `We've e-mailed you instructions for setting your password to the e-mail address you submitted.
     You should be receiving it shortly.`;
  }

  ngOnInit() {
  }

  onNavigateToSignIn(): void {
    this.router.navigate([`/${ROUTE_SIGNIN}`]);
  }
}
